import { PlanUnitMix } from 'components/types';

export const setLastUsedPlanunit = (payload: PlanUnitMix[]) => ({
  type: 'SET_QUALITY_MONITOR_LAST_USED_PLANUNIT',
  payload
});

export type LastUsedPlanunitAction = ReturnType<typeof setLastUsedPlanunit>;
